import useSWRMutation, { SWRMutationConfiguration, SWRMutationResponse } from 'swr/mutation'
import { COMMENT_API_PREFIX } from 'shared/api/constants/api-constants'
import { adaptFetcherToSWRMutationFn } from 'shared/api/utils/adapt-fetcher-to-swr-mutation'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'

interface UseUnpinCommentOptions {
  commentId: number
  config?: SWRMutationConfiguration<void, Error, string, undefined>
}

export const useUnpinComment = ({
  commentId,
  config,
}: UseUnpinCommentOptions): SWRMutationResponse<void, Error, string, undefined> => {
  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.delete, void, void>({
    method: RequestMethodsEnum.delete,
    notFoundResponseHandler() {},
  })

  return useSWRMutation(
    `${COMMENT_API_PREFIX}/${commentId}/pin`,
    adaptFetcherToSWRMutationFn<void, undefined>(fetcher),
    config,
  )
}
